export enum AnimationName {
  Walk = "Walk",
  Attack = "Attack",
  Strike = "Strike",
  Shoot = "Shoot",
  Sleep = "Sleep",
  Hurt = "Hurt",
  Idle = "Idle",
  Swing = "Swing",
  Hop = "Hop",
  Charge = "Charge",
  MultiScratch = "MultiScratch",
  MultiStrike = "MultiStrike",
  Punch = "Punch",
  Kick = "Kick",
  SpAttack = "SpAttack",
  Stomp = "Stomp",
  Roar = "Roar",
  Dance = "Dance",
  Shake = "Shake",
  Emit = "Emit",
  Shock = "Shock",
  Bite = "Bite",
  Withdraw = "Withdraw",
  Slice = "Slice",
  Uppercut = "Uppercut",
  Rumble = "Rumble",
  RearUp = "RearUp",
  Appeal = "Appeal",
  TailWhip = "TailWhip",
  Scratch = "Scratch",
  Slam = "Slam",
  Sing = "Sing",
  Lick = "Lick",
  Ricochet = "Ricochet",
  Jab = "Jab",
  Pose = "Pose",
  Sound = "Sound",
  Rotate = "Rotate",
}

// Array of all valid animation names for easy iteration
export const VALID_ANIMATIONS = Object.values(AnimationName);
